import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

/**
 * Fetches a single record by id (clockInAt, clockOutAt, project, assignment, ...).
 * Used by the activity-log dialog to show record details when a row is expanded.
 */
export const getRecordById = async (recordId, activeEmployerInfo = {}) => {
  const apiPath = `records/${recordId}`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    activeEmployerInfo,
    isLocalApiRequest: true,
  });

  const response = await axios(signedRequest);

  return response.data;
};
